import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ExternalItemMappingPage from './pages/ExternalItemMappingPage';
import BomManagementPage from './pages/BomManagementPage';
import BomItemsPage from './pages/BomItemsPage';
import CostToCompletionPage from './pages/CostToCompletionPage';
import ReportsPage from './pages/ReportsPage';
import BackOrderTrackingPage from './pages/BackOrderTrackingPage';

const BomRoutes = () => {
  return (
    <Routes>
      <Route path="external-item-mapping" element={<ExternalItemMappingPage />} />
      <Route path="management" element={<BomManagementPage />} />
      <Route path="management/:bomId/items" element={<BomItemsPage />} />
      <Route path="reports" element={<ReportsPage />} />
      <Route path="reports/cost-to-completion" element={<CostToCompletionPage />} />
      <Route path="reports/back-order-tracking" element={<BackOrderTrackingPage />} />
    </Routes>
  );
}

export default BomRoutes;
